import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

export const options = {
    responsive: true,
    plugins: {
        legend: {
            position: 'top',
        },
        title: {
            display: false,
            text: 'Készlet két dátum között',
        },
    },
};

export function Stock({ stockData, receivers }) {
    // Extract dates and sort them
    const dates = Object.keys(stockData).sort();

    // Map receiver IDs to their names and colors
    const receiverMap = receivers.reduce((acc, receiver) => {
        acc[receiver.id] = {
            name: receiver.name,
            color: receiver.color,
        };
        return acc;
    }, {});

    // Generate datasets for each receiver
    const datasets = Object.keys(receiverMap).map(receiverId => {
        return {
            label: receiverMap[receiverId].name,
            data: dates.map(date => stockData[date][receiverId] || 0), // Default to 0 if no data
            borderColor: receiverMap[receiverId].color,
            backgroundColor: receiverMap[receiverId].color, // Adding transparency
        };
    });

    const data = {
        labels: dates,
        datasets,
    };

    return <Line options={options} data={data} />;
}
